import React from "react";

import { Grid, Typography } from "@mui/material";

import FiltersReport from "../components/FiltersReport";
import ReportBuilder from "../components/shared/ReportBuilder/ReportBuilder";
import DataLoader from "../components/DataLoader";

import { DISPLAY_ELEMENT_HELPER } from "../helpers/filters";
import { REPORT_CHART_HEATMAP_CALENDAR } from "../components/shared/ReportBuilder/ReportHeatMapCalendar";
import { REPORT_TABLE_RESERVATIONS } from "../components/shared/ReportBuilder/ReportTableReservations";
import { REPORT_TABLE_METRICS_SUMMARY } from "../components/shared/ReportBuilder/ReportTableMetricsSummary";

const REPORTS = [
    {
        type: REPORT_TABLE_RESERVATIONS,
    },
    {
        type: REPORT_TABLE_METRICS_SUMMARY,
        groupBy: [],
        // dataType: DATATYPE_CHECKIN,
        fieldsOrder: [
            "bookingsTotal",
            "roomNightsTotal",
            "revenueRoom",
            "ADRTotal",
            // "ALoSTotal",
            // "ABWTotal",
            // "BWTotal",
            // "bookingsCancelled",
        ],
        hideFields: [
            ...Object.keys(DISPLAY_ELEMENT_HELPER).filter(
                (e) =>
                    ![
                        "bookingsTotal",
                        "roomNightsTotal",
                        "revenueRoom",
                        "ADRTotal",
                        // "ALoSTotal",
                        // "ABWTotal",
                        // "BWTotal",
                        // "bookingsCancelled",
                    ].includes(e),
            ),
        ],
    },
    { type: REPORT_CHART_HEATMAP_CALENDAR },
];

const ReservationsTableScreen = () => {
    return (
        <>
            <DataLoader Reservations />
            <Grid container>
                <Grid item sx={{ mt: 2, mb: 2 }} xs={12}>
                    <Typography variant="h4">Reservations Table</Typography>
                    <Typography variant="">
                        This table shows the reservations under the filters.
                    </Typography>
                </Grid>
            </Grid>
            <FiltersReport
                hideExports
                defaultValues={{
                    // presetDate: PRESET_NEXT_12_MONTHS,
                    // filters: {
                    //     Cancellations: "included",
                    //     Comparison: "previousYear",
                    // },
                    groupBy: [],
                }}
                hide={
                    [
                        //     "DATATYPE",
                        //     "FILTERS_VOUCHERS",
                        //     "COMPARISON",
                        //     "CANCELLATIONS_ONLY",
                    ]
                }
                setProcessed={() => {}}
            />
            <ReportBuilder reports={REPORTS} />
        </>
    );
};

export default ReservationsTableScreen;
